import { createContext } from 'react';
import { TenantContextType } from '@trashlab/sitesapp/src/contexts/tenant-types';

export const TenantContext = createContext<TenantContextType>({
  website: null,
  isLoading: true,
  isPreview: false,
  isEditMode: false,
});
